<template>
 <div class="app-container">
   <div class="formBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class="formItemBox">
          <el-form-item label="捆包编号:" class="">
            <el-input placeholder="可支持多个" type="textarea" v-model="searchFrom.cargoBarcode"></el-input>
          </el-form-item>
          <el-form-item label="创建时间:" class="item2">
                <el-date-picker
                    v-model="searchFrom.createTimes"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                     :default-time="['00:00:00', '23:59:59']"
                ></el-date-picker>
              </el-form-item>
          <template v-for="(column,index) in searchList" >
              <el-form-item label="结算客户:" v-if="column.enName=='payee'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select  v-model="searchFrom.payee" filterable allow-create placeholder="请选择" @focus="jskhFocus" clearable>
                  <el-option  label="全部" value="" ></el-option>
                  <el-option v-for="item in kehuList" :label="item.payee" :value="item.payee" :key="item.payee"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="运单编号:" class="item1" v-else-if="column.enName=='wayNo'&&(index<seacrchNum||topShow)" :key="column.enName" >
                  <el-input placeholder="可支持多个" type="textarea" v-model="searchFrom.wayNo" ></el-input>
              </el-form-item>
              <el-form-item label="订单编号:" v-else-if="column.enName=='orderNo'&&(index<seacrchNum||topShow)" :key="column.enName" class="item1">
                <el-input placeholder="可支持多个" type="textarea" v-model="searchFrom.ddbh"></el-input>
              </el-form-item>
              <el-form-item label="货物类型:" v-else-if="column.enName=='productTypeName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select  v-model="searchFrom.productTypeName" filterable placeholder="请选择" clearable>
                  <el-option  label="全部" value="" ></el-option>
                  <el-option v-for="item in HWlist" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="司机归属:"  v-else-if="column.enName=='driverOwnershipName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.driverOwnershipName" placeholder="请选择" clearable>
                  <el-option label="全部" value="" ></el-option>
                  <el-option label="自有" value="自有" ></el-option>
                  <el-option label="外协" value="外协" ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="车船归属:"  v-else-if="column.enName=='vehicleOwnershipName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.vehicleOwnershipName" placeholder="请选择" clearable>
                  <el-option label="全部" value="" ></el-option>
                  <el-option label="自有" value="自有" ></el-option>
                  <el-option label="外协" value="外协" ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="承运商/部门:" v-else-if="column.enName=='generalCarrier'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select  v-model="searchFrom.generalCarrier" filterable placeholder="请选择" clearable>
                  <el-option v-for="item in CYSList" :label="item.generalCarrier" :value="item.generalCarrier" :key="item.generalCarrier"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="运单状态:" v-else-if="column.enName=='wayStateName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.wayStateArr" multiple  placeholder="请选择" clearable>
                  <!-- <el-option label="全部" value="" ></el-option> -->
                  <el-option label="待配载" value="0" ></el-option>
                  <el-option label="待装车" value="1" ></el-option>
                  <el-option label="运输中" value="2" ></el-option>
                  <el-option label="待签收" value="3" ></el-option>
                  <el-option label="已签收" value="4" ></el-option>
                  <!-- <el-option label="已作废" value="5" ></el-option> -->
                </el-select>
              </el-form-item>
              <el-form-item label="风控状态:" v-else-if="column.enName=='signRiskControlStateName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.signRiskControlState" placeholder="请选择" clearable>
                  <el-option label="不风控" value="1" ></el-option>
                  <el-option label="待风控" value="2" ></el-option>
                  <el-option label="风控通过" value="3" ></el-option>
                  <el-option label="风控异常" value="4" ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="网货状态:" v-else-if="column.enName=='onlinePushStatusName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.onlineAddPushFlag"   placeholder="请选择" clearable>
                  <el-option label="全部" value="全部" ></el-option>
                  <el-option label="不推送风控平台" value="不推送风控平台" ></el-option>
                  <el-option label="风控平台推送中" value="风控平台推送中" ></el-option>
                  <el-option label="已推送风控平台" value="已推送风控平台" ></el-option>
                  <el-option label="风控平台推送失败" value="风控平台推送失败" ></el-option>
                  <el-option label="已推送三方网货" value="已推送三方网货" ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="能源类型:" v-else-if="column.enName=='energyTypeName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.energyTypeName" placeholder="请选择" clearable>
                  <el-option label="全部" value="" ></el-option>
                  <el-option label="******" value="******" ></el-option>
                  <el-option label="其他" value="其他" ></el-option>
                  <el-option label="汽油" value="汽油" ></el-option>
                  <el-option label="柴油" value="柴油" ></el-option>
                  <el-option label="天然气" value="天然气" ></el-option>
                  <el-option label="电" value="电" ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="配载重量:" v-else-if="column.enName=='dispatchWeightNum'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-input placeholder="" v-number-input.float="3" v-model="searchFrom.dispatchWeightT" ></el-input>
              </el-form-item>
              <el-form-item label="结算量:" v-else-if="column.enName=='liquidatedAmountNum'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-input placeholder=""  v-number-input.float="3" v-model="searchFrom.liquidatedAmount" ></el-input>
              </el-form-item>
               <el-form-item label="卸车量:" v-else-if="column.enName=='unloadingsNum'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-input placeholder="" v-number-input.float="3" v-model="searchFrom.unloadings" ></el-input>
              </el-form-item>
              <el-form-item label="实际签收时间:" class="item2" v-else-if="column.enName=='actualSigningTime'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-date-picker
                    v-model="searchFrom.actualSigningTime"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['00:00:00', '23:59:59']"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="实际装车时间:" class="item2" v-else-if="column.enName=='actualLoadingTime'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-date-picker
                    v-model="searchFrom.actualLoadingTime"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['00:00:00', '23:59:59']"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="业务部门:"  v-else-if="column.enName=='businessSubunit'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select  v-model="searchFrom.businessSubunit" filterable placeholder="请选择" @change="bumenChangeCX" clearable>
                  <el-option  label="全部" value="" ></el-option>
                  <el-option v-for="item in bumenList" :label="item.name" :value="item.name" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="业务人员:"  v-else-if="column.enName=='businessUser'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select  v-model="searchFrom.businessUser" filterable placeholder="请选择" clearable>
                  <el-option  label="全部" value="" ></el-option>
                  <el-option v-for="item in yonghuList" :label="item.userName" :value="item.userName" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="业务类型:"  v-else-if="column.enName=='wayBusinessTypeName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.wayBusinessType" placeholder="请选择" clearable>
                  <el-option  label="全部" value="" ></el-option>
                  <el-option v-for="item in YWLXlist" :label="item.showName" :value="item.itemNo" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否往返:"  v-else-if="column.enName=='arriveDepartFlag'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.arriveDepartFlag" placeholder="请选择" clearable>
                  <el-option label="全部" value="" ></el-option>
                  <el-option label="是" value="是" ></el-option>
                  <el-option label="否" value="否" ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="超时报警:"  v-else-if="column.enName=='timeoutReminder'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.timeoutReminder" placeholder="请选择" clearable>
                  <el-option label="全部" value="" ></el-option>
                  <el-option label="装车超时" value="1" ></el-option>
                  <el-option label="卸车超时" value="2" ></el-option>
                  <el-option label="签收超时" value="3" ></el-option>
                </el-select>
              </el-form-item>
               <el-form-item label="收入结算状态:"  v-else-if="column.enName=='ysSettlementStatesName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.ysSettlementStates" placeholder="请选择结算状态" clearable>
                  <el-option v-for="item in ysSettlementList" :label="item.showName" :key="item.value"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="收入开票状态:"  v-else-if="column.enName=='ysInvoicingStatesName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.ysInvoicingStates" placeholder="请选择开票状态" clearable>
                  <el-option v-for="item in ysInvoicingList" :label="item.showName" :key="item.showName" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="所属小队:"  v-else-if="column.enName=='teamOrgName'&&(index<seacrchNum||topShow)" :key="column.enName">
                  <el-select v-model="searchFrom.teamOrgCode" filterable placeholder="请选择" clearable >
                    <el-option v-for="item in XDList" :label="item.name" :value="item.code" :key="item.id"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="装车量:"  v-else-if="column.enName=='truckloadNum'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-input  placeholder=""  v-number-input.float="3"    maxlength="8"  v-model="searchFrom.truckload"></el-input>
              </el-form-item>
               <el-form-item label="推送首钢:"  v-else-if="column.enName=='pl3PushFlag'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.pl3PushFlag" placeholder="请选择" clearable>
                  <el-option label="全部" value="" ></el-option>
                  <el-option label="是" :value="0" ></el-option>
                  <el-option label="否" :value="1" ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="运输方式:"  v-else-if="column.enName=='transportModeName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.transportMode" placeholder="请选择" clearable>
                  <el-option label="全部" value="" ></el-option>
                  <el-option label="汽运" :value="1" ></el-option>
                  <el-option label="海运" :value="2" ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="收入结算状态:"  v-else-if="column.enName=='ysSettlementStatesName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.ysSettlementStates" placeholder="请选择结算状态" clearable>
                  <el-option v-for="item in ysSettlementList" :label="item.showName" :key="item.value"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="收入开票状态:"  v-else-if="column.enName=='ysInvoicingStatesName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.ysInvoicingStates" placeholder="请选择开票状态" clearable>
                  <el-option v-for="item in ysInvoicingList" :label="item.showName" :key="item.showName" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
               <template v-else >
                  <el-form-item :label="column.cnName+':'"  :key="column.enName" v-if="(index<seacrchNum||topShow)">
                    <el-input placeholder="" v-model="searchFrom[column.enName]" ></el-input>
                  </el-form-item>
               </template>

          </template>
          <el-form-item label="合约编号:" >
            <el-input placeholder="" v-model="searchFrom.agreementNumber" ></el-input>
          </el-form-item>
        </div>
        <div style="display: flex;justify-content: space-between;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox">
            <el-button type="primary" v-if="btnFlg[0]" size="mini" @click="searchFn">查询</el-button>
            <el-button type="primary" v-if="btnFlg[2]" @click="exportFn" size="mini" :disabled="isDisable">导出</el-button>
            <el-button type="primary"  v-if="btnFlg[1]" size="mini" @click="resetForm('searchFrom')">重置</el-button>
            <el-button type="primary" v-if="btnFlg[3]" size="mini" @click="addFn">新增</el-button>
            <el-button type="primary" v-if="btnFlg[4]" size="mini" @click="dayinFN">打印</el-button>
            <el-button type="primary" v-if="btnFlg[5]" size="mini" @click="wangfanXZFn">往返</el-button>
            <el-button type="primary" v-if="btnFlg[6]" size="mini" @click="editMoneyFn(1)">修改收入</el-button>
            <el-button type="primary" v-if="btnFlg[7]" size="mini" @click="editMoneyFn(2)">修改支出</el-button>
            <el-button type="primary" v-if="btnFlg[8]" size="mini" @click="editMoneyFn(3)">修改仓储费</el-button>
            <el-button type="primary" v-if="btnFlg[17]" size="mini" @click="exportHWFn"  :disabled="isDisable">货物导出</el-button>
            <el-button type="primary" v-if="btnFlg[19]" size="mini" @click="whbzFn"  :disabled="isDisable">网货备注</el-button>
            <el-button type="primary" v-if="btnFlg[22]" size="mini" @click="tuisonggangkouFN"  >推送港口</el-button>
            <el-button type="primary" v-if="btnFlg[25]" size="mini" @click="quxiaochecihaoFN"  >取消车次号</el-button>
            <el-button type="primary" @click="importFn" size="mini"  v-if="btnFlg[26]">导入</el-button>
            <el-button type="primary" @click="modelDown" size="mini" v-if="btnFlg[26]">模板下载</el-button>
          </div>
          <div @click="tabSetting"><i class="el-icon-s-tools"></i></div>
        </div>
        <div style="margin-left:10px">
          <el-form-item>
           <p class="margin0">总配载量:<span class="red">{{statistics.dispatchWeightT}}</span>吨/
           <span class="red">{{statistics.dispatchNumber}}</span>件/
           <span class="red">{{statistics.dispatchVolumn}}</span>方</p>
          </el-form-item>
          <el-form-item >
           <p class="margin0">总卸车量:<span class="red">{{statistics.unloadings}}</span></p>
          </el-form-item>
          <el-form-item >
           <p class="margin0">总结算量:<span class="red">{{statistics.liquidatedAmount}}</span></p>
          </el-form-item>
          <el-form-item >
           <p class="margin0">总收入含税总额:<span class="red">{{statistics.grossRevenue|moneyFormatNew}}</span>元</p>
          </el-form-item>
          <el-form-item>
           <p class="margin0">总运费金额:<span class="red">{{statistics.freightAmount|moneyFormatNew}}</span>元</p>
          </el-form-item>
          <el-form-item>
           <p class="margin0">总支出含税总额:<span class="red">{{statistics.freightTaxTotal|moneyFormatNew}}</span>元</p>
          </el-form-item>
          <el-form-item>
           <p class="margin0">已选结算量:<span class="red">{{yixuanData.yxjsl}}</span>{{yixuanData.danwei}}</p>
          </el-form-item>
           <el-form-item>
           <p class="margin0">已选支出含税合计:<span class="red">{{yixuanData.yxzchshj|moneyFormatNew}}</span>元</p>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="openBox">
      <div class="openChild" v-if="topShow" @click="topFn">
        <i class="el-icon-caret-top" ></i>
      </div>
      <div class="openChild" v-if="!topShow" @click="topFn">
        <i class="el-icon-caret-bottom" ></i>
      </div>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList" v-if="tabHeadList.length>0"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods' class="tableComent"
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border :cell-class-name="myclass" :cell-style="getCellStyle" :row-class-name="({row}) => selectedRows.some(r=>r.wayBusinessId==row.wayBusinessId)?'sel-row':''">
       <el-table-column type="selection" width="55" fixed></el-table-column>
       <el-table-column  type="index" width="55" label="序号" fixed></el-table-column>
        <el-table-column label="操作" width="260" fixed>
          <template slot-scope="scope">
            <!-- @click.stop：避免点操作按钮时冒泡到 row-click，把刚选中的行又取消掉（高亮闪一下消失） -->
            <div @click.stop>
              <!-- 网货运单 -->
              <span v-if="scope.row.onlineAddPushFlag==1||scope.row.onlineAddPushFlag == 4">
                <el-button v-if="btnFlg[9]&&scope.row.ysSettlementStates==-1&&scope.row.yfSettlementStates==-1&&scope.row.wayState<4&&scope.row.designateSubdepartmentCode  ==orgSubCode&&
                scope.row.waySource!=2&&scope.row.auditStatus!=1"
                  type="text" size="mini" @click="editFn(scope.row)">修改</el-button>
                <!-- 只有运输中待签收 -->
                <el-button v-if="btnFlg[11]&&scope.row.ysSettlementStates==-1&&scope.row.yfSettlementStates==-1&&((scope.row.wayState==2)||
                (scope.row.wayState==3&&(scope.row.auditStatus=='0'||scope.row.auditStatus==2||scope.row.auditStatus==3)))&& scope.row.designateSubdepartmentCode  ==orgSubCode"
                type="text" size="mini"  @click="pingzhengWHFn(scope.row)">装卸</el-button>
                <el-button v-if="btnFlg[18]&&scope.row.ysSettlementStates==-1&&scope.row.yfSettlementStates==-1&&
                (scope.row.wayState==3&&(scope.row.auditStatus==1||scope.row.auditStatus==3))&& scope.row.designateSubdepartmentCode  ==orgSubCode"
                type="text" size="mini"  @click="qianshouWHFn(scope.row)">签收</el-button>
                <!-- 只要已签收能撤回 -->
                <el-button  v-if="btnFlg[15]&&scope.row.ysSettlementStates==-1&&scope.row.yfSettlementStates==-1&&scope.row.wayState==4"
                  type="text" size="mini"  @click="chehuiFn(scope.row)">撤回</el-button>
              </span>
              <!-- 非网货运单和推送网货失败的运单 -->
              <span v-if="scope.row.onlineAddPushFlag==null||scope.row.onlineAddPushFlag==''||scope.row.onlineAddPushFlag==3">
                <el-button v-if="btnFlg[9]&&scope.row.ysSettlementStates==-1&&scope.row.yfSettlementStates==-1&&scope.row.wayState<4&&scope.row.designateSubdepartmentCode  ==orgSubCode&&scope.row.waySource!=2"
                  type="text" size="mini" @click="editFn(scope.row)">修改</el-button>
                <el-button v-if="btnFlg[11]&&scope.row.ysSettlementStates==-1&&scope.row.yfSettlementStates==-1&&(scope.row.wayState==1||scope.row.wayState==2||scope.row.wayState==3)"
                type="text" size="mini"  @click="pingzhengFn(scope.row)">装卸</el-button>
                <!-- 签收按钮新加逻辑 待风控、风控异常不可进行签收操作 (1不风控 2待风控 3风控通过 4风控异常)-->
                <el-button v-if="btnFlg[18]&&scope.row.ysSettlementStates==-1&&scope.row.yfSettlementStates==-1&&(scope.row.wayState==3)&&(scope.row.designateSubdepartmentCode  ==orgSubCode||(scope.row.createDepartmentCode ==orgCode&&scope.row.cancellationFlag==1)) && (scope.row.signRiskControlState =='1' || scope.row.signRiskControlState =='3')"
                type="text" size="mini"  @click="qianshouFn(scope.row,0)">签收</el-button>
                <el-button v-if="btnFlg[23]&&scope.row.ysSettlementStates==-1&&scope.row.yfSettlementStates==-1&&(scope.row.wayState==3)&&(scope.row.designateSubdepartmentCode  ==orgSubCode||(scope.row.createDepartmentCode ==orgCode&&scope.row.cancellationFlag==1))"
                type="text" size="mini"  @click="qianshouFn(scope.row,1)">强制签收</el-button>
                <el-button  v-if="btnFlg[15]&&scope.row.ysSettlementStates==-1&&scope.row.yfSettlementStates==-1&&scope.row.wayState==4" type="text" size="mini"  @click="chehuiFn(scope.row)">撤回</el-button>
              </span>
              <el-button type="text" style="margin-left:8px" size="mini" v-if="btnFlg[10]" @click="addFn(2,scope.row)">复制</el-button>
              <el-button type="text" size="mini" style="margin-left:8px"  v-if="btnFlg[12]&&scope.row.wayState<4&&!((scope.row.productTypeName=='中厚板'||scope.row.productTypeName=='剪切板')&&scope.row.waySource==2 )&&
                scope.row.designateSubdepartmentCode ==orgSubCode&&scope.row.cancellationFlag==1 " @click="zuofeiFn(scope.row)">作废</el-button>
              <el-button type="text" size="mini" style="margin-left:8px"  v-if="btnFlg[13]" @click="jiluFn(scope.row)">记录</el-button>
              <el-button type="text" size="mini" style="margin-left:8px"  v-if="btnFlg[14]" @click="fujianFn(scope.row)">附件</el-button>
              <el-button type="text" size="mini" style="margin-left:8px"  v-if="btnFlg[20]&&scope.row.onlineAddPushFlag==3" @click="tuisongFn(scope.row)">推送风控</el-button>
               <el-button type="text" style="margin-left:8px" size="mini" v-if="btnFlg[21]&&scope.row.wayState==4&&scope.row.waySource!=4" @click="kelongFn(scope.row)">克隆</el-button>
               <el-button v-if="btnFlg[24]&&scope.row.ysSettlementStates==-1&&scope.row.yfSettlementStates==-1&&(scope.row.wayState==3)&&(scope.row.designateSubdepartmentCode==orgSubCode||scope.row.createDepartmentCode ==orgCode)" type="text" size="mini" @click="fengkongFn(scope.row,0)">风控</el-button>
               <!-- <el-button type="text" v-if="btnFlg[5]&&!scope.row.roundTripNo" size="mini" @click="wangfanXZFn(scope.row)">往返</el-button> -->
            </div>
          </template>
        </el-table-column>
        <template v-for="(column,index) in tabHeadList">
          <template v-if="column.enName=='wayNo'">
            <el-table-column property=""  width="240" label="运单编号" :fixed="index<2" :key="column.enName">
              <template slot-scope="scope">
                <span class="textColer" @click="detailFn(scope.row)">{{scope.row.wayNo}}</span>
              </template>
            </el-table-column>
          </template>
          <template v-else-if="column.enName=='weightDifferenceRate'">
            <el-table-column property=""  width="100" label="磅差率(‰)" :fixed="index<2" :key="column.enName">
              <template slot-scope="scope">
                <span  v-if="(-3<scope.row.weightDifferenceRate)&&(scope.row.weightDifferenceRate<3)" >{{scope.row.weightDifferenceRate}}</span>
                <span style="color: #D51212;" v-else >{{scope.row.weightDifferenceRate?scope.row.weightDifferenceRate:'-'}}</span>
              </template>
            </el-table-column>
          </template>
          <!--  <template v-else-if="column.enName=='whAuditStatusName'">
            <el-table-column property=""  width="120" label="网货提示" :fixed="index<2"  :key="column.enName">
              <template slot-scope="scope">
                <span v-if="scope.row.onlineAddPushrlag==3">>
                  {{scope.row.onlineMessage?scope.row.onlineMessage:'-'}}
                </span>
                <span v-else-if="scope.row.onlineUpdateTimes==3">
                  {{scope.row.onlineMessage}}
                </span>
                <span v-else>
                  <span style="color: #0c46a2;cursor: pointer;" @click="shenhejiluFn(scope.row)" v-if="scope.row.auditStatus==1||scope.row.auditStatus==2"
                  >{{scope.row.whAuditStatusName}}</span>
                  <span  v-else >{{scope.row.whAuditStatusName?scope.row.whAuditStatusName:'-'}}</span>
                </span>
              </template>
            </el-table-column>
          </template> -->
          <template v-else-if="column.enName=='wayStateName'">
            <el-table-column property=""  width="100" label="状态" :fixed="index<2" :key="column.enName">
              <template slot-scope="scope">
                <span style="color: #E99D42;" v-if="scope.row.wayState==2" >{{scope.row.wayStateName}}</span>
                <span style="color: #D51212;" v-else-if="scope.row.wayState==3" >{{scope.row.wayStateName}}</span>
                <span style="color: #81B337;" v-else-if="scope.row.wayState==4" >{{scope.row.wayStateName}}</span>
                <span style="color: #9A9A9A;" v-else-if="scope.row.wayState==5" >{{scope.row.wayStateName}}</span>
                <span  v-else >{{scope.row.wayStateName}}</span>
              </template>
            </el-table-column>
          </template>

          <template v-else>
            <el-table-column :key="column.enName" :prop="column.enName" :label="column.cnName" :fixed="index<2" :width="column.fieldWidth" show-overflow-tooltip :formatter="formatterRowEmpty">
              <template v-for="item in column.child">
                <el-table-column property="" v-if="item.enName=='revenueSurcharge'"  width="150" label="收入附加费(元)" :key="item.enName">
                  <template slot-scope="scope">
                    <span style="color: #81B337;" v-if="scope.row.revenueSurcharge>0" >{{scope.row.revenueSurcharge}}</span>
                    <span style="color: #D51212;" v-else-if="scope.row.revenueSurcharge<0" >{{scope.row.revenueSurcharge}}</span>
                    <span v-else >{{scope.row.revenueSurcharge}}</span>
                  </template>
                </el-table-column>
                <el-table-column property="" v-else-if="item.enName=='disburseSurcharge'"  width="150" label="支出附加费(元)" :key="item.enName">
                  <template slot-scope="scope">
                    <span style="color: #81B337;" v-if="scope.row.disburseSurcharge>0" >{{scope.row.disburseSurcharge}}</span>
                    <span style="color: #D51212;" v-else-if="scope.row.disburseSurcharge<0" >{{scope.row.disburseSurcharge}}</span>
                    <span v-else >{{scope.row.disburseSurcharge?scope.row.disburseSurcharge:'-'}}</span>
                  </template>
                </el-table-column>
                <el-table-column v-else :key="item.enName" :prop="item.enName" :label="item.cnName"  :width="item.fieldWidth" show-overflow-tooltip :formatter="formatterRowEmpty">
                </el-table-column>
              </template>
            </el-table-column>
          </template>
        </template>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,500]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

    <!-- 装卸凭证 -->
    <zhuangxiupinzheng v-if="pingzhengFlag" :rowData="goodform" :pingzhengFlag.sync="pingzhengFlag"></zhuangxiupinzheng>
     <!-- 装卸凭证网货 -->
    <zhuangxiupinzhengWH v-if="pingzhengWHFlag" :rowData="goodform" :pingzhengWHFlag.sync="pingzhengWHFlag"></zhuangxiupinzhengWH>
    <!-- 修改各种价格 -->
    <xiugaifeiyong v-if="moneyDialog" :rowData="goodform" :moneyDialog.sync="moneyDialog"></xiugaifeiyong>
    <!-- 作废 -->
    <el-dialog  title="作废" :close-on-click-modal="false" :close-on-press-escape="false"  @close="ZFflag = false"  :visible.sync="ZFflag" width="400px" center>
      <div>
        <el-form  :inline="true" :rules="rules"  ref="ZFform" :model="ZFform"  class="demo-form-inline"  label-width="80px"  size="mini"  >
          <el-form-item label="作废原因" class="item1" prop="causeCancellation">
            <el-input placeholder="" type="textarea" maxlength="100" v-model="ZFform.causeCancellation" class="gjh"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="ZFflag = false">取 消</el-button>
        <el-button type="primary" @click="ZFsaveFn()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 记录 -->
    <el-dialog  title="调价记录" :close-on-click-modal="false" :close-on-press-escape="false"   :visible.sync="jiluFlag" width="800px" center>
      <div>
        <el-table height="400px" size="mini" ref="tabref" :data="jiluList" style="width:100%"  border center>
          <el-table-column type="index"  label="序号" width="60"></el-table-column>
          <el-table-column prop="modifyItem" min-width="130" label="修改项"></el-table-column>
          <el-table-column prop="modifyContent" min-width="200"  label="修改后"></el-table-column>
          <el-table-column prop="createUser" min-width="130" label="修改人"></el-table-column>
          <el-table-column prop="createTime" min-width="170" :formatter="dateTimeFormat" label="创建时间"></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="jiluFlag = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 审核记录 -->
    <el-dialog  title="审核记录" :close-on-click-modal="false" :close-on-press-escape="false"   :visible.sync="SHjiluFlag" width="800px" center>
      <div>
        <el-timeline>
          <el-timeline-item  v-for="(activity, index) in SHjiluList" :key="index" :color="SHjiluList.length-1 ? '#0bbd87' : ''">
            <p>审核时间：{{activity.createTime|dateFormat}}</p>
            <p>审核人：{{activity.createUserName}}</p>
            <p>审核操作：{{[ "待审核", "审核通过", "审核驳回" ,"不审核"][activity.auditStatus]}}</p>
            <p v-if="activity.auditOpinion">审核结果：{{activity.auditOpinion}}</p>
          </el-timeline-item>
        </el-timeline>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="SHjiluFlag = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 附件 -->
    <el-dialog  title="附件" :close-on-click-modal="false" :close-on-press-escape="false"   :visible.sync="fujianFlag" width="500px" center>
      <div class="fujianBox">
         <el-button type="text" v-for="item in fujianList" @click="fujianClick(item)" :key="item.id">{{item.name}}</el-button>
      </div>
      <el-dialog  title="查看图片" :close-on-click-modal="false" :close-on-press-escape="false"   :visible.sync="lookImgFlag"
        append-to-body width="800px" center>
        <div style="text-align: right;">
          <el-button type="primary" @click="dayinImgFn">打印</el-button>
          <div id="printMe"  ref="print">
            <el-image style="width: 100%;" :src="imgUrl" fit="contain"></el-image>
          </div>
        </div>
      </el-dialog>
    </el-dialog>
    <!-- 网货备注 -->
    <el-dialog  title="网货备注" :close-on-click-modal="false" :close-on-press-escape="false"  @close="WHBZflag = false"  :visible.sync="WHBZflag" width="600px" center>
      <div>
        <el-form  :inline="true" :rules="rules"  ref="WHBZform" :model="WHBZform"  class="demo-form-inline"  label-width="80px"  size="mini"  >
          <el-form-item label="备注" class="item1" prop="onlineRemark">
            <el-input placeholder="" type="textarea" maxlength="200" v-model="WHBZform.onlineRemark" style="width:400px"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="WHBZflag = false">取 消</el-button>
        <el-button type="primary" @click="WHBZsaveFn()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 新建运单 -->
    <addWay v-if="addFlag" :addFlag.sync="addFlag" :oldWayId="oldWayId" :wayBusinessId="wayBusinessId" :glhwFlag="btnFlg[16]?true:false" @updateCreateTimes="updateCreateTimes"></addWay>
    <!-- 修改运单 -->
    <editWay v-if="editFlag" :editFlag.sync="editFlag" :wayBusinessId="wayBusinessId" :glhwFlag="btnFlg[16]?true:false"></editWay>
    <!-- 运单签收 -->
    <qianshou v-if="qianshouFlag"  :qianshouFlag.sync="qianshouFlag" :isCheckGps="isCheckGps" :wayBusinessId="wayBusinessId" ></qianshou>
     <!-- 网货运单签收 -->
    <qianshouWH v-if="qianshouWHFlag" :qianshouWHFlag.sync="qianshouWHFlag" :wayBusinessId="wayBusinessId" ></qianshouWH>
     <!-- 设置表头 -->
    <table-heads v-if="tableMark" :tableMark.sync='tableMark' :groupCode="groupCode" @refresh = 'queryMyPageField'></table-heads>
    <export-setting v-if="exportMark" :exportMark.sync='exportMark' :groupCode="groupCode"
   @exportList='exportList'></export-setting>
    <!-- 克隆运单 -->
    <kelong v-if="kelongFlag" :kelongFlag.sync="kelongFlag" :wayBusinessId="wayBusinessId"  @updateCreateTimes="updateCreateTimes"></kelong>
    <!-- 风控 -->
    <fengkong v-if="fengkongFlag" :fengkongFlag.sync="fengkongFlag" :wayBusinessId="wayBusinessId" ></fengkong>
    <!-- 导入 -->
    <importC   v-if="importDialog" danwei="M" size="5" @DRsave="DRsave" @destroy="destroy"></importC>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { formatterRowEmpty, dateTimeFormat, dateFormat, dateFormat1, toFixed, getMorenTime } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import importC from '@/components/import1.vue'
import addWay from '@/views/newTMS/publicFiles/wayManage/addWay.vue'
import editWay from '@/views/newTMS/publicFiles/wayManage/editWay.vue'
import qianshou from '@/views/newTMS/publicFiles/wayManage/qianshou.vue'
import qianshouWH from '@/views/newTMS/publicFiles/wayManage/qianshouWH.vue'
import fengkong from '@/views/newTMS/publicFiles/wayManage/fengkong.vue'
import zhuangxiupinzheng from '@/views/newTMS/publicFiles/wayManage/zhuangxiupinzheng.vue'
import zhuangxiupinzhengWH from '@/views/newTMS/publicFiles/wayManage/zhuangxiupinzhengWH.vue'
import xiugaifeiyong from '@/views/newTMS/publicFiles/wayManage/xiugaifeiyong.vue'
import tableHeads from '@/views/newTMS/publicFiles/tableHeades.vue'
import exportSetting from '@/views/newTMS/publicFiles/exportSetting.vue'
import { getDictionaryDetailList, findGcDropDownBox, queryMyPageField, findWayList, voidWay, findWayFiles,
  cancelRoundTripNo, createRoundTripNo, cancelWay, findPriceAdjustmentRecord, voidSgStowageWay, queryWayAuditDetail,
  findWayListStatistics, updateOnlineRemark, findWayPayeeList, riskControlPush, checkOrderSource, pushWharf, cancelWayTrainNumber, importWay } from '@/api/newTMS'
import { getCurrUserDepartment, getDepartmentUsers } from '@/api/newCrm'
import { organizationTree } from '@/api/vgs-driver2.0'
import kelong from '@/views/newTMS/publicFiles/wayManage/kelong.vue'
import SearchCollapse from '@/components/common/SearchCollapse.vue'
export default {
  components: {
    addWay, editWay, zhuangxiupinzheng, tableHeads, exportSetting, xiugaifeiyong, zhuangxiupinzhengWH, qianshou, qianshouWH, kelong, SearchCollapse, fengkong, importC
  },
  data () {
    return {
      groupCode: 'platformWay',
      tableMark: false,
      exportMark: false,
      tabHeadList: [],
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      formatterRowEmpty: formatterRowEmpty,
      dialogVisible: false,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        orderNo: this.$route.query.orderNo
      },
      total: 0,
      loading: false,
      isDisable: false,
      importDialog: false,
      addFlag: false,
      editFlag: false,
      glhwFlag: false,
      pingzhengFlag: false,
      moneyDialog: false,
      fujianFlag: false,
      fujianList: [],
      lookImgFlag: false,
      imgUrl: '',
      rules: {
        // publishPricingMethod: [
        //   { required: true, message: '请选择计价方式', trigger: 'blur' }
        // ],
        // pricingMethod: [
        //   { required: true, message: '请选择计价方式', trigger: 'blur' }
        // ],
        // unitPrice: [
        //   { required: true, message: '请输入价格', trigger: 'blur' }
        // ],
        causeCancellation: [
          { required: true, message: '请输入作废原因', trigger: 'blur' }
        ],
        onlineRemark: [
          { required: true, message: '请输入网货备注', trigger: 'blur' }
        ]
      },
      kehuList: [],
      HWlist: [],
      goodform: {},
      list: [
        { name: '订单编号' },
        { name: '收入', child: [{ name: '收入总额' }] },
        { name: '支出', child: [{ name: '支出总额' }] }
      ],
      wayBusinessId: '',
      ZFflag: false,
      ZFform: {},
      jiluFlag: false,
      jiluList: [],
      orgSubCode: localStorage.getItem('orgSubCode'),
      orgCode: localStorage.getItem('orgCode'),
      pingzhengWHFlag: false,
      SHjiluFlag: false,
      SHjiluList: [],
      statistics: {},
      yixuanData: {
        yxzchshj: 0,
        yxjsl: 0
      },
      qianshouFlag: false,
      qianshouWHFlag: false,
      bumenList: [],
      yonghuList: [],
      YWLXlist: [],
      WHBZflag: false, // 网货备注
      WHBZform: {},
      topShow: false,
      ysSettlementList: [
        {
          showName: '全部',
          value: ''
        },
        {
          showName: '未对账',
          value: '-1'
        },
        {
          showName: '未收款',
          value: '0'
        },
        {
          showName: '部分收款',
          value: '1'
        },
        {
          showName: '已收款',
          value: '2'
        },
        {
          showName: '不收款',
          value: '3'
        }
      ],
      ysInvoicingList: [
        {
          showName: '全部',
          value: ''
        },
        {
          showName: '待申请',
          value: '0'
        },
        {
          showName: '部分开票',
          value: '1'
        },
        {
          showName: '待开票',
          value: '11'
        },
        {
          showName: '已开票',
          value: '2'
        },
        {
          showName: '不开票',
          value: '3'
        }
      ],
      kelongFlag: false,
      CYSList: [],
      searchList: [],
      seacrchNum: window.innerWidth > 1680 ? 7 : 5,
      isCheckGps: 0,
      btnFlg: [],
      btnIdArr: ['01N0030100', '01N0030200', '01N0030300', '01N0030400', '01N0030500', '01N0030600', '01N0030700', '01N0030800',
        '01N0030900', '01N0030A00', '01N0030B00', '01N0030C00', '01N0030D00', '01N0030E00',
        '01N0030F00', '01N0030G00', '01N0030H00', '01N0030I00', '01N0030J00', '01N0030K00', '01N0030L00', '01N0030M00', '01N0030N00', '01N0030O00', '01N0030P00',
        '01N0030Q00', '01N0030R00'],
      fengkongFlag: false,
      oldWayId: null,
      XDList: [],
      selectedRows: []
    }
  },
  created () {
    getDictionaryDetailList({ dictionaryType: 'goods_type' }).then(res => { this.HWlist = res })
    getDictionaryDetailList({ dictionaryType: 'business_type' }).then(res => { this.YWLXlist = res })
    getDictionaryDetailList({ dictionaryType: 'settlement_pricing' }).then(res => { this.SRJJlist = res })
    organizationTree({ flag: 1 }).then((res) => {
      if (res[0].orgType == 1) {
        this.XDList = res[0].children
      } else {
        this.XDList = res
      }
    })
    // findCustomerInfoList({ businessType: 1 }).then(res => { this.kehuList = res })
    // this.getkehuFn()
    findGcDropDownBox().then(res => {
      this.CYSList = res
    })
    getCurrUserDepartment().then(res => { this.bumenList = res })
    this.btnFlg = getBtn(this.btnIdArr, '/qiYunWay')
    if (!this.$route.query.orderNo) {
      this.$set(this.searchFrom, 'createTimes', getMorenTime())
    }
    // this.getList(this.searchFrom)
    this.queryMyPageField()
  },
  mounted () {
  },
  methods: {
    // 取消车次号
    quxiaochecihaoFN () {
      let selectData = this.$refs.table.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
        return
      }
      // if (selectData.length > 10) {
      //   this.$alert('最多只能选择10条数据', '系统提示')
      //   return
      // }
      let arr = selectData.map(item => item.wayId)
      this.$confirm('是否执行取消车次号操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        cancelWayTrainNumber({
          wayIds: arr
        }).then(res => {
          loading.close()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    getHeight () {
      this.$nextTick(() => {
        let h = this.$refs.searchBox.offsetHeight
        let pH = document.documentElement.clientHeight
        this.h = (pH - h - 170) + 'px'
      })
    },
    topFn () {
      this.topShow = !this.topShow
      this.getHeight()
      this.seacrchNum = window.innerWidth > 1680 ? 8 : 6
    },
    // 推送港口
    tuisonggangkouFN () {
      let selectData = this.$refs.table.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
        return
      }
      if (selectData.length > 10) {
        this.$alert('最多只能选择10条数据', '系统提示')
        return
      }
      let arr = selectData.map(item => item.wayId)
      this.$confirm('是否执行推送港口操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        pushWharf({
          ids: arr
        }).then(res => {
          loading.close()
          this.$message({
            message: '推送成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 克隆运单
    kelongFn (row) {
      this.wayBusinessId = row.wayBusinessId
      this.kelongFlag = true
    },
    // 推送风控平台
    tuisongFn (row) {
      this.$confirm('是否执行推送风控操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        riskControlPush({
          wayBusinessId: row.wayBusinessId
        }).then(res => {
          loading.close()
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 结算客户获取焦点
    jskhFocus () {
      this.getkehuFn()
    },
    // 报警颜色设置
    getCellStyle ({ row, column, rowIndex, columnIndex }) {
      if (column.label == '超时报警') {
        if (row.timeoutReminder == '装车超时') {
          return { color: '#FEB0A4' }
        } else if (row.timeoutReminder == '卸车超时') {
          return { color: '#FDCC0F' }
        } else if (row.timeoutReminder == '签收超时') {
          return { color: 'red' }
        } else {
          return { }
        }
      }
    },
    //
    updateCreateTimes () {
      this.$set(this.searchFrom, 'createTimes', getMorenTime())
    },
    // 获取结算客户
    getkehuFn () {
      if (this.searchFrom.wayNo) {
        let wayNoStr = this.searchFrom.wayNo.trim()
        this.searchFrom.wayNos = wayNoStr.replace(/\n/g, ',')
      } else {
        this.searchFrom.wayNos = ''
      }
      if (this.searchFrom.ddbh) {
        let ddhStr = this.searchFrom.ddbh.trim()
        this.searchFrom.orderNos = ddhStr.replace(/\n/g, ',')
      } else {
        this.searchFrom.orderNos = ''
      }
      if (this.searchFrom.cargoBarcode) {
        let kbhStr = this.searchFrom.cargoBarcode.trim()
        this.searchFrom.cargoBarcodes = kbhStr.replace(/\n/g, ',')
      } else {
        this.searchFrom.cargoBarcodes = ''
      }
      if (this.searchFrom.createTimes) {
        this.searchFrom.createTimeStart = this.searchFrom.createTimes[0]
        this.searchFrom.createTimeEnd = this.searchFrom.createTimes[1]
      } else {
        this.searchFrom.createTimeStart = ''
        this.searchFrom.createTimeEnd = ''
      }
      if (this.searchFrom.actualSigningTime) {
        this.searchFrom.actualSigningTimeStart = this.searchFrom.actualSigningTime[0]
        this.searchFrom.actualSigningTimeEnd = this.searchFrom.actualSigningTime[1]
      } else {
        this.searchFrom.actualSigningTimeStart = ''
        this.searchFrom.actualSigningTimeEnd = ''
      }
      if (this.searchFrom.actualLoadingTime) {
        this.searchFrom.actualLoadingTimeStart = this.searchFrom.actualLoadingTime[0]
        this.searchFrom.actualLoadingTimeEnd = this.searchFrom.actualLoadingTime[1]
      } else {
        this.searchFrom.actualLoadingTimeStart = ''
        this.searchFrom.actualLoadingTimeEnd = ''
      }
      if (this.searchFrom.wayStateArr) {
        this.searchFrom.wayStates = this.searchFrom.wayStateArr.toString()
      } else {
        this.searchFrom.wayStates = ''
      }
      findWayPayeeList(this.searchFrom).then(res => { this.kehuList = res })
    },
    // 网货备注
    whbzFn () {
      let selectData = this.$refs.table.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
        return
      }
      let arr = selectData.map(item => item.wayId)
      this.WHBZflag = true
      this.WHBZform = {
        wayIds: arr
      }
    },
    WHBZsaveFn () {
      this.$refs.WHBZform.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          updateOnlineRemark(this.WHBZform).then(res => {
            loading.close()
            this.WHBZflag = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 部门查询
    bumenChangeCX (e) {
      let json1 = this.bumenList.filter(item => item.name == e)
      getDepartmentUsers({ subOrgCode: json1[0].code }).then(res => { this.yonghuList = res })
    },
    // 网货签收
    qianshouWHFn (row) {
      this.qianshouWHFlag = true
      this.wayBusinessId = row.wayBusinessId
    },
    // 非网货签收
    qianshouFn (row, n) {
      this.qianshouFlag = true
      this.wayBusinessId = row.wayBusinessId
      this.isCheckGps = n
    },
    // 修改单元格样式的方法
    myclass ({ row, column, rowIndex, columnIndex }) {
      if (column.label == '网货提示') {
        if (row.onlineMessage) {
          return 'warning-row'
        } else {
          return ''
        }
      }
    },
    // 审核记录
    shenhejiluFn (row) {
      queryWayAuditDetail({ wayNo: row.wayNo }).then(res => {
        if (res.length == 0) {
          this.$alert('此运单没有审核记录', '系统提示')
        } else {
          this.SHjiluFlag = true
          this.SHjiluList = res
        }
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    // 打印
    dayinFN () {
      let selectData = this.$refs.table.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        let ids = selectData.map(item => item.wayBusinessId)
        this.$router.push({ name: 'tmsWayDayin', query: { ids: ids.toString() } })
      }
    },
    // 记录
    jiluFn (row) {
      findPriceAdjustmentRecord({ wayId: row.wayId }).then(res => {
        if (res.length == 0) {
          this.$alert('此运单没有调价记录', '系统提示')
        } else {
          this.jiluFlag = true
          this.jiluList = res
        }
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    // 撤回
    chehuiFn (row) {
      this.$confirm('是否执行撤回操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        cancelWay({
          wayId: row.wayId, wayBusinessId: row.wayBusinessId
        }).then(res => {
          loading.close()
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 附件
    fujianFn (row) {
      findWayFiles({ wayId: row.wayId }).then(res => {
        if (res.length == 0) {
          this.$alert('此运单没有附件', '系统提示')
        } else {
          this.fujianFlag = true
          this.fujianList = []
          res.forEach(item => {
            var filename = item.url.split('/').pop()
            this.fujianList.push({
              name: filename,
              url: item.fileKeyUrl
            })
          })
        }
      })
    },
    fujianClick (row) {
      if (this.isImage(row.name)) {
        this.lookImgFlag = true
        this.imgUrl = row.url
      } else {
        window.open(row.url)
      }
    },
    dayinImgFn () {
      this.$print(this.$refs.print)
    },
    isImage (filename) {
      const extension = filename.split('.').pop().toLowerCase()
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg']
      return imageExtensions.includes(extension)
    },
    // 详情
    detailFn (row) {
      this.$router.push({ name: 'tmsWayDetails', query: { id: row.wayBusinessId } })
    },
    // 作废
    zuofeiFn (row) {
      this.ZFflag = true
      this.ZFform = {}
      this.ZFform.wayId = row.wayId
      this.ZFform.wayBusinessId = row.wayBusinessId
      this.ZFform.waySource = row.waySource
      this.ZFform.goodsYn = row.goodsYn
    },
    ZFsaveFn () {
      this.$refs.ZFform.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          if (this.ZFform.waySource == 2) {
            voidSgStowageWay(this.ZFform).then(res => {
              loading.close()
              this.ZFflag = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            voidWay(this.ZFform).then(res => {
              loading.close()
              this.ZFflag = false
              this.getList(this.searchFrom)
              if (this.ZFform.goodsYn == 1) {
                this.$message({
                  message: '操作成功,货物已释放到原订单，请重新配货。',
                  type: 'success'
                })
              }
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }
        }
      })
    },
    tabSetting () {
      this.tableMark = true
    },
    // 查询我的页面表头
    queryMyPageField () {
      this.tabHeadList = []
      queryMyPageField({
        // 入参：tagCode 分组编码： 订单列表-> orderPage 运单列表-> wayPage 收支列表-> szPage
        tagCode: this.groupCode
      }).then(res => {
        this.tabHeadList = res
        this.searchList = []
        res.forEach(item => {
          if (item.child.length > 0) {
            item.child.forEach(childItem => {
              if (childItem.isSettingQuery == 1) {
                this.searchList.push(childItem)
              }
            })
          } else {
            if (item.isSettingQuery == 1) {
              this.searchList.push(item)
            }
          }
        })
        this.getHeight()
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    // 打印
    dayinFn () {

    },
    // 往返
    wangfanFn () {
      let selectData = this.$refs.table.selection
      if (selectData.length != 2) {
        this.$alert('请选择两条要操作的数据', '系统提示')
        return
      }
      if (selectData[0].wayState == 5 || selectData[1].wayState == 5) {
        this.$alert('已作废的订单不能关联往返', '系统提示')
        return
      }
      let danhao = selectData[0].roundTripNo == '' ? null : selectData[0].roundTripNo
      let danhao1 = selectData[1].roundTripNo == '' ? null : selectData[1].roundTripNo
      console.log(danhao, '236')
      console.log(selectData[1].roundTripNo, '123')
      if (danhao == danhao1) {
        if (!danhao) { // 关联往返
          this.$confirm('确定关联往返吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            createRoundTripNo({
              wayIds: [selectData[0].wayId, selectData[1].wayId]
            }).then(res => {
              loading.close()
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }).catch(() => {

          })
        } else { // 取消关联
          this.$confirm('取消关联往返吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            cancelRoundTripNo({
              wayIds: [selectData[0].wayId, selectData[1].wayId]
            }).then(res => {
              loading.close()
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }).catch(() => {

          })
        }
      } else {
        this.$alert('往返单号不同不能一起操作', '系统提示')
      }
    },
    // 修改各种价格
    editMoneyFn (n) {
      let selectData = this.$refs.table.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
        return
      }

      let flag2 = selectData.every(item => item.designateSubdepartmentCode == this.orgSubCode)
      this.goodform.wayBusinessIds = []
      let srjj = []
      let zcjj = []
      let hwlx = []
      let isFS = false
      let isWH = false
      let WHlist = []
      let orederBId = []
      selectData.forEach(item => {
        this.goodform.wayBusinessIds.push(item.wayBusinessId)
        srjj.push(item.revenueValuation)
        zcjj.push(item.freightPricingType)
        hwlx.push(item.productType)
        if (item.onlineAddPushFlag == 1 || item.onlineAddPushFlag == 4) {
          isWH = true
          WHlist.push(item)
        }
        if (item.reverseCountFlag == 1) {
          isFS = true
        }
        if (item.orderBusinessId) {
          orederBId.push(item.orderBusinessId)
        }
      })
      this.goodform.moneyFlag = n
      this.goodform.measuringUnit = selectData[0].measuringUnit
      if (n == 1) {
        let ysFlag = selectData.every(item => item.ysSettlementStates == -1)
        if (!ysFlag) {
          this.$alert('只有应收账单未对账才能修改', '系统提示')
          return
        }
        if (new Set(srjj).size !== 1) {
          this.$alert('请选择收入计价一样的运单进行操作', '系统提示')
          return
        }
        this.goodform.title = '修改收入'
        if (orederBId.length > 0) {
          // 转包不可以修改支出计价
          checkOrderSource({
            orderBusinessIds: orederBId
          }).then(res => {
            if (res == '1') {
              this.goodform.isZhanbao = true
            } else {
              this.goodform.isZhanbao = false
            }
            this.moneyDialog = true
          })
        } else {
          this.moneyDialog = true
        }
      }
      if (n == 2) {
        let yfFlag = selectData.every(item => item.yfSettlementStates == -1)
        let tszFlag = selectData.every(item => item.onlineAddPushFlag != '0' && item.onlineAddPushFlag != 2)// 推送中不能改支出
        if (!yfFlag) {
          this.$alert('只有应付账单未对账才能修改', '系统提示')
          return
        }
        // if (!flag2) {
        //   this.$alert('只能修改本部门创建的运单', '系统提示')
        //   return
        // }
        if (!tszFlag) {
          this.$alert('推送中的运单不能修改支付', '系统提示')
          return
        }
        if (new Set(zcjj).size > 2) {
          this.$alert('请选择运费计价一样的运单进行操作', '系统提示')
          return
        } else if (new Set(zcjj).size == 2) {
          if (zcjj.indexOf('1') == -1) {
            this.$alert('请选择运费计价一样的运单进行操作', '系统提示')
            return
          }
        }
        if (isWH) {
          this.goodform.onlinePushFlag = 1
          let flag3 = WHlist.some(item => item.wayState == 4)
          this.goodform.whqsFlag = flag3// 推送网货已签收,不能修改运费计价
        } else {
          this.goodform.onlinePushFlag = null
        }
        this.goodform.isFS = isFS // 是否反算
        this.goodform.title = '修改支出'
        this.moneyDialog = true
      }
      if (n == 3) {
        let flag1 = selectData.every(item => item.wayState < 4)
        if (!flag1) {
          this.$alert('已签收的运单不能修改', '系统提示')
          return
        }
        if (!flag2) {
          this.$alert('只能修改本部门创建的运单', '系统提示')
          return
        }
        if (new Set(hwlx).size !== 1) {
          this.$alert('请选择货物类型一样的运单进行操作', '系统提示')
          return
        }
        this.goodform.title = '修改仓储费'
        this.moneyDialog = true
      }
    },
    // 装卸凭证
    pingzhengFn (row) {
      this.goodform = { ...row }
      this.pingzhengFlag = true
    },
    pingzhengWHFn (row) {
      this.goodform = { ...row }
      this.pingzhengWHFlag = true
    },
    async exportList (val) {
      if (this.searchFrom.wayNo) {
        let wayNoStr = this.searchFrom.wayNo.trim()
        this.searchFrom.wayNos = wayNoStr.replace(/\n/g, ',')
      } else {
        this.searchFrom.wayNos = ''
      }
      if (this.searchFrom.ddbh) {
        let ddhStr = this.searchFrom.ddbh.trim()
        this.searchFrom.orderNos = ddhStr.replace(/\n/g, ',')
      } else {
        this.searchFrom.orderNos = ''
      }
      if (this.searchFrom.cargoBarcode) {
        let kbhStr = this.searchFrom.cargoBarcode.trim()
        this.searchFrom.cargoBarcodes = kbhStr.replace(/\n/g, ',')
      } else {
        this.searchFrom.cargoBarcodes = ''
      }
      if (this.searchFrom.createTimes) {
        this.searchFrom.createTimeStart = this.searchFrom.createTimes[0]
        this.searchFrom.createTimeEnd = this.searchFrom.createTimes[1]
      } else {
        this.searchFrom.createTimeStart = ''
        this.searchFrom.createTimeEnd = ''
      }
      if (this.searchFrom.actualSigningTime) {
        this.searchFrom.actualSigningTimeStart = this.searchFrom.actualSigningTime[0]
        this.searchFrom.actualSigningTimeEnd = this.searchFrom.actualSigningTime[1]
      } else {
        this.searchFrom.actualSigningTimeStart = ''
        this.searchFrom.actualSigningTimeEnd = ''
      }
      if (this.searchFrom.actualLoadingTime) {
        this.searchFrom.actualLoadingTimeStart = this.searchFrom.actualLoadingTime[0]
        this.searchFrom.actualLoadingTimeEnd = this.searchFrom.actualLoadingTime[1]
      } else {
        this.searchFrom.actualLoadingTimeStart = ''
        this.searchFrom.actualLoadingTimeEnd = ''
      }
      if (this.searchFrom.wayStateArr) {
        this.searchFrom.wayStates = this.searchFrom.wayStateArr.toString()
      } else {
        this.searchFrom.wayStates = ''
      }
      this.isDisable = true
      let form = { ...this.searchFrom }
      delete form.pageNo
      delete form.pageSize
      form.header = val
      await exportExcel(
        this.global.tmsPlus + '/way/exportWayList',
        form,
        '运单列表'
      )
      this.isDisable = false
    },
    // 导出
    exportFn () {
      if (this.total > 10000) {
        this.$alert('最多导出10000条数据', '系统提示')
        return
      }
      this.exportMark = true
    },
    // 货物导出
    async exportHWFn () {
      this.isDisable = true
      let form = { ...this.searchFrom }
      delete form.pageNo
      delete form.pageSize
      await exportExcel(
        this.global.tmsPlus + '/way/exportWayGoodList',
        form,
        '货物列表'
      )
      this.isDisable = false
    },
    // 导入
    importFn () {
      this.importDialog = true
    },
    // 导入模板下载
    modelDown () {
      var tempwindow = window.open('_blank') // 先打开页面
      tempwindow.location = 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/tms/excel/运单导入模版.xlsx'// 后更改页面地址
    },
    DRsave (formData) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      // formData.append('params', JSON.stringify({ monthlyPlanMasterId: this.rowData.id }))
      importWay(formData).then(res => {
        loading.close()
        this.importDialog = false
        this.msg = this.$message({
          showClose: true,
          message: res,
          duration: 3000,
          type: 'success',
          onClose () {

          }
        })
        this.getList(this.searchFrom)
      }).catch(err => {
        if (err.code == -1) {
          this.$message({
            type: 'warning',
            message: err.data ? err.data : err.message,
            onClose () {
              loading.close()
            }
          })
          this.isDisable = false
        } else if (err.code == 1) {
          this.isDisable = false
          this.$confirm('存在异常信息，是否确认导出异常信息?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const loading = this.$loading({
              lock: true,
              text: '正在导出异常信息...'
            })
            let form = {}
            exportExcel(
              this.global.smpName +
                    '/monthlyFundPlanMaster/exportMonthlyFundPlanDetailExc',
              form,
              '异常信息表'
            )
            setTimeout(() => {
              this.$message({
                type: 'success',
                message: err.data
              })
              loading.close()
              this.daoRuMark = false
              this.importDialog = false
              this.getList(this.searchFrom)
            }, 3000)
          }).catch(() => {
            this.daoRuMark = false
            this.$message({
              type: 'warning',
              message: '已取消异常信息导出，' + err.data,
              onClose () {
                loading.close()
              }
            })
          })
        } else {
          loading.close()
        }
      })
    },
    destroy () {
      this.importDialog = false
    },
    // 修改
    editFn (row) {
      console.log('editFlag')
      this.editFlag = true
      this.wayBusinessId = row.wayBusinessId
    },
    // 新建
    addFn (flag, row) {
      if (flag == 2) { // 复制
        this.wayBusinessId = row.wayBusinessId
        this.oldWayId = null
        this.addFlag = true
      } else {
        this.addFlag = true
        this.wayBusinessId = null
        this.oldWayId = null
      }
    },
    wangfanXZFn () {
      let selectData = this.$refs.table.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
        return
      }
      const flag = selectData.some(item => item.roundTripNo && item.roundTripNo.trim() !== '')
      if (flag) {
        this.$alert('所选数据含有往返运单，暂不支持重复往返', '系统提示')
        return
      }
      this.wayBusinessId = selectData[0].wayBusinessId
      this.oldWayId = selectData.map(itme => itme.wayId)
      this.addFlag = true
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      this.selectedRows = selection
      if (selection.length > 0) {
        this.yixuanData.yxzchshj = 0.00
        this.yixuanData.yxjsl = 0.00
        this.yixuanData.danwei = selection[0].measuringUnit
        selection.forEach((item, index) => {
          this.yixuanData.yxzchshj += item.freightTaxTotal
          this.yixuanData.yxjsl += isNaN(item.liquidatedAmount) ? 0 : item.liquidatedAmount
        })
        if (selection[0].measuringUnit == '件') {
          this.yixuanData.yxjsl = toFixed(this.yixuanData.yxjsl, 0)
        } else {
          this.yixuanData.yxjsl = toFixed(this.yixuanData.yxjsl, 3)
        }
        console.log(this.yixuanData)
        this.$forceUpdate()
      }
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    async getList () {
      if (this.searchFrom.wayNo) {
        let wayNoStr = this.searchFrom.wayNo.trim()
        this.searchFrom.wayNos = wayNoStr.replace(/\n/g, ',')
      } else {
        this.searchFrom.wayNos = ''
      }
      if (this.searchFrom.ddbh) {
        let ddhStr = this.searchFrom.ddbh.trim()
        this.searchFrom.orderNos = ddhStr.replace(/\n/g, ',')
      } else {
        this.searchFrom.orderNos = ''
      }
      if (this.searchFrom.cargoBarcode) {
        let kbhStr = this.searchFrom.cargoBarcode.trim()
        this.searchFrom.cargoBarcodes = kbhStr.replace(/\n/g, ',')
      } else {
        this.searchFrom.cargoBarcodes = ''
      }
      if (this.searchFrom.createTimes) {
        this.searchFrom.createTimeStart = this.searchFrom.createTimes[0]
        this.searchFrom.createTimeEnd = this.searchFrom.createTimes[1]
      } else {
        this.searchFrom.createTimeStart = ''
        this.searchFrom.createTimeEnd = ''
      }
      if (this.searchFrom.actualSigningTime) {
        this.searchFrom.actualSigningTimeStart = this.searchFrom.actualSigningTime[0]
        this.searchFrom.actualSigningTimeEnd = this.searchFrom.actualSigningTime[1]
      } else {
        this.searchFrom.actualSigningTimeStart = ''
        this.searchFrom.actualSigningTimeEnd = ''
      }
      if (this.searchFrom.actualLoadingTime) {
        this.searchFrom.actualLoadingTimeStart = this.searchFrom.actualLoadingTime[0]
        this.searchFrom.actualLoadingTimeEnd = this.searchFrom.actualLoadingTime[1]
      } else {
        this.searchFrom.actualLoadingTimeStart = ''
        this.searchFrom.actualLoadingTimeEnd = ''
      }
      if (this.searchFrom.wayStateArr) {
        this.searchFrom.wayStates = this.searchFrom.wayStateArr.toString()
      } else {
        this.searchFrom.wayStates = ''
      }
      // let zcBJ = 0
      // let xcBJ = 0
      // let qsBJ = 0
      // 超时报警逻辑开始是前端实现的，后来后端处理了
      // try {
      //   let BJlist = await getDictionaryDetailList({
      //     dictionaryType: 'timeout_reminder'
      //   })
      //   BJlist.forEach(item => {
      //     if (item.itemNo == 1) { // 装车超时
      //       zcBJ = item.remark * 60 * 60 * 1000
      //     } else if (item.itemNo == 2) { // 卸车超时
      //       xcBJ = item.remark * 60 * 60 * 1000
      //     } else if (item.itemNo == 3) { // 签收超时
      //       qsBJ = item.remark * 60 * 60 * 1000
      //     }
      //   })
      // } catch (error) {
      //   this.$message({
      //     showClose: true,
      //     message: error.message,
      //     type: 'error',
      //     onClose () {
      //       this.loading = false
      //     }
      //   })
      // }
      this.loading = true
      findWayList(this.searchFrom).then(res => {
        this.loading = false
        // let tableArr = []
        // const currentDate = new Date().getTime()
        if (Array.isArray(res.list)) {
          // res.list.forEach(item => {
          //   if (item.wayState == 1 && zcBJ) { // 待装车
          //     let cjsj = Date.parse(item.createTime)
          //     item.timeoutReminder = cjsj + zcBJ < currentDate ? '装车超时' : '正常'
          //   } else if (item.wayState == 2 && xcBJ) { // 运输中
          //     let zcsj = Date.parse(item.actualLoadingTime)
          //     item.timeoutReminder = zcsj + zcBJ < currentDate ? '卸车超时' : '正常'
          //   } else if (item.wayState == 3 && qsBJ) { // 待签收
          //     let xcsj = Date.parse(item.actualUnloadingTime)
          //     item.timeoutReminder = xcsj + zcBJ < currentDate ? '签收超时' : '正常'
          //   } else {
          //     item.timeoutReminder = '正常'
          //   }
          //   tableArr.push(item)
          // })
          this.tableList = res.list
          this.total = res.total
        }
      }).catch(error => {
        console.log(Date.now())
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            this.loading = false
          }
        })
      })
      findWayListStatistics(this.searchFrom).then(res => {
        if (res) {
          this.statistics = res
        } else {
          this.statistics = {
            dispatchNumber: 0,
            dispatchVolumn: 0,
            dispatchWeightT: 0,
            freightAmount: 0,
            freightAmountTotal: 0,
            freightTaxTotal: 0,
            grossRevenue: 0,
            liquidatedAmount: 0,
            unloadings: 0

          }
        }
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            this.loading = false
          }
        })
      })
      this.yixuanData = {
        yxzchshj: 0,
        yxjsl: 0
      }
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTime: null
      }
      this.$set(this.searchFrom, 'createTimes', getMorenTime())
    },

    closeDialog () {
      this.$refs['SQFrom'].clearValidate()
      this.SQFrom = {
      }
    },
    fengkongFn (row) {
      this.fengkongFlag = true
      this.wayBusinessId = row.wayBusinessId
    }
  },
  activated () {
    if (!this.$route.meta.isBack) { // 清空查询条件
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTime: null
      }
      if (this.$route.query.orderNo) {
        this.$set(this.searchFrom, 'orderNo', this.$route.query.orderNo)
      } else {
        this.$set(this.searchFrom, 'createTimes', getMorenTime())
      }
      this.getList(this.searchFrom)
    } else {
      this.$route.meta.isBack = false
      this.$set(this.searchFrom, 'orderNo', this.$route.query.orderNo)
      this.getList(this.searchFrom)
    }
  },
  // watch: {
  //   searchFrom: {
  //     handler (newName, oldName) {
  //        this.getkehuFn()
  //     },
  //     deep: true
  //   }
  // },
  // inject: ['reload'],页面会加载两次 所以换一种写法
  beforeRouteEnter (to, from, next) {
    if (from.path == '/tmsWayDetails') {
      to.meta.isBack = true
    } else {
      to.meta.isBack = false
    }
    next()
  }
  // beforeRouteLeave (to, from, next) {
  //   if (to.path == '/tmsWayDetails') {
  //     from.meta.keepAlive = true
  //   } else {
  //     from.meta.keepAlive = false
  //   }
  //   next()
  // }
}
</script>

<style scoped lang='less'>
.searchBtnBox{
  margin: 10px 0;
}
.inpBox .el-date-editor{
  width: 430px!important;
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
.jiage .el-form-item__content {
  position: relative;
  .identiCode1 {
    position: absolute;
    right: 14px;
    color: #409eff;
  }
  .danwei1 {
    position: absolute;
    right: 14px;
    color: white;
    padding: 7px 4px;
  }
}
.fujianBox{
  display: flex;
  flex-direction: column;
  /deep/.el-button--text{
    text-align: left;
    margin-left: 0;
    margin-bottom: 10px;
  }
}
/deep/.el-form{
  width: 100%;
}
.box{
  width: 100%;
   display: grid;
   grid-template-columns: repeat(auto-fill, 280px);
   grid-auto-flow: row dense;
   /deep/.el-textarea__inner{
    width: 150px;
    height: 68px;
   }
   .item1{
      grid-row-start: span 2;
    }
   .item2{
      grid-column-start: span 2;
      width: 540px;
   }
}
.margin0{
  margin-right: 20px!important;
}
/deep/.el-table .warning-row {
    background: #ffc7c1!important;
  }
// 用于消除固定列下方的伪元素边框线

/deep/ .table {
    .el-table__fixed:before {
      height: 0px;
    }
}
.openBox{
  width: 100%;
}
.openChild{
  width: 50px;
  height: 12px;
  margin: 0 auto;
  border: solid 1px #e4e2e2;
  border-bottom: none;
  background-color: #f5f5f5;
  border-top-right-radius:5px ;
  border-top-left-radius:5px ;
  line-height: 12px;
  text-align: center;
  cursor: pointer;
}
.bottomChild{
  width: 50px;
  height: 12px;
  margin: 0 auto;
  border: solid 1px #e4e2e2;
  border-top: none;
  background-color: #f5f5f5;
  border-bottom-right-radius:5px;
  border-bottom-left-radius:5px;
}
// 由于windows和mac两端系统不一致，el-table滚动条样式渲染的也不同，mac的滚动条要比windows的窄一些，我这边做了高度差
/*CSS 本身不能检测操作系统，但可以检测浏览器的引擎。Mac 和 Windows 的默认浏览器（Safari 和 Edge/Chrome）使用不同的引擎（WebKit 和 Blink），可以利用 @supports 规则来实现不同样式。不过，这种方法不是完全可靠，因为它依赖于特定的引擎行为。*/
/* 针对 WebKit 浏览器 (可能是 Windows) */
@supports (-webkit-touch-callout: none) {
  /deep/ .table .el-table__fixed {
      height: calc(100% - 20px) !important;
  }
}

/* 针对非 WebKit 浏览器 (可能是 Mac) */
@supports not (-webkit-touch-callout: none) {
  /deep/ .table .el-table__fixed {
      height: calc(100% - 12px) !important;
  }
}
/* 高亮必须写在 td 上：element-ui 自带 .el-table--enable-row-hover .el-table__body tr:hover>td{background:#F5F7FA}，
   会给 td 铺一层不透明灰底，写在 tr 上的颜色会被 td 盖住，表现为鼠标划过高亮消失 */
/deep/ .el-table__body tr.sel-row > td {
  background-color: #b0d0f3 !important;
}
/* 选中行悬停时保持蓝色，不再被 hover 的灰底覆盖 */
/deep/ .el-table--enable-row-hover .el-table__body tr.sel-row:hover > td {
  background-color: #b0d0f3 !important;
}
</style>
